import { render, staticRenderFns } from "./DeferDialog.vue?vue&type=template&id=2b98c049&"
import script from "./DeferDialog.vue?vue&type=script&lang=js&"
export * from "./DeferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports